<template>
  <span>{{ typedText }}</span>
</template>

<script setup>
  import { ref, onMounted } from 'vue'

  const props = defineProps({
    text: {
      type: String,
      required: true,
    },
    delay: {
      type: Number,
      default: 50,
    },
  })

  const emit = defineEmits(['typing-complete'])

  const typedText = ref('')

  const typeEffect = async () => {
    for (let i = 0; i < props.text.length; i++) {
      typedText.value += props.text[i]
      await new Promise((resolve) => setTimeout(resolve, props.delay))
    }
    await new Promise((resolve) => setTimeout(resolve, 1500)) // 1.5초 대기
    emit('typing-complete')
  }

  onMounted(() => {
    typeEffect()
  })
</script>

<style scoped>
  /* 필요한 스타일을 여기에 추가할 수 있습니다. */
  /* 예를 들어, 커서 깜빡임 효과 등을 추가할 수 있습니다. */
  /* span { */
  /*   border-right: .15em solid orange; */
  /*   animation: */
  /*     typing 3.5s steps(40, end), */
  /*     blink-caret .75s step-end infinite; */
  /*   white-space: nowrap; */
  /*   overflow: hidden; */
  /* } */

  /* @keyframes typing { */
  /*   from { width: 0 } */
  /*   to { width: 100% } */
  /* } */

  /* @keyframes blink-caret { */
  /*   from, to { border-color: transparent } */
  /*   50% { border-color: orange; } */
  /* } */
</style>
